import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import usePageProps from '@/routes/usePageProps';
import StoresByCategoryPage from '@/pages/StoresByCategoryPage';

const Stores: React.FC<RouteComponentProps> = props => {
  const pageProps = usePageProps({ props });

  if (pageProps.reducersState.app.loadingPlatformConfig) {
    return null;
  }

  return <StoresByCategoryPage {...pageProps} />
};

export default Stores;
